// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"CredentialsSelectModal_subtitle_31FVi","footer":"CredentialsSelectModal_footer_yrx1y"};